import { Calendar, Award, Flame, TrendingUp, Bookmark, Trophy, Sparkles } from "lucide-react";
import HubLayout from "./HubLayout";

export default function Penny() {
  return (
    <HubLayout
      eyebrow="Penny"
      headline="Your coach,"
      italic="keeping track."
      subhead="Today's plan, your streak, the badges you've earned, the gaps Penny noticed. Everything that's about you, in one place."
      cards={[
        {
          Icon: Sparkles, accent: "var(--gold-500)",
          title: "Penny Insights",
          lede: "What Penny picked up from how you've been showing up. One specific next step, AI-coached.",
          to: "/penny/insights",
        },
        {
          Icon: Calendar, accent: "var(--gold-500)",
          title: "Today's plan",
          lede: "Your two-hour daily target — one hour written, one hour oral. Penny tracks both, gently.",
          to: "/dashboard",
        },
        {
          Icon: TrendingUp, accent: "var(--sage)",
          title: "Your progress",
          lede: "Days completed, words mastered, score curves. The slow proof that this is working.",
          to: "/progress",
        },
        {
          Icon: Award, accent: "var(--gold-500)",
          title: "Achievements",
          lede: "Thirty quiet seals across four tiers. Bronze for showing up, diamond for the rare ones.",
          to: "/achievements",
        },
        {
          Icon: Flame, accent: "var(--rust)",
          title: "Streak & history",
          lede: "Every day you showed up. The streak freezes you've earned. The comebacks that matter.",
          to: "/history",
        },
        {
          Icon: Calendar, accent: "var(--sky)",
          title: "Monthly calendar",
          lede: "Perfect days in sage, partial in gold, missed in dusk. A month at a glance.",
          to: "/calendar",
        },
        {
          Icon: Bookmark, accent: "var(--ink-700)",
          title: "Saved",
          lede: "Words, phrases, sentences you bookmarked for later. Penny brings them back when you need them.",
          to: "/bookmarks",
        },
        {
          Icon: Trophy, accent: "var(--gold-500)",
          title: "Leaderboard",
          lede: "How you stack up this week — quietly, no pile-ons.",
          to: "/leaderboard",
        },
      ]}
    />
  );
}
